import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { a as TaktIdProvider } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const StyledList = /*#__PURE__*/styled.ol.withConfig({
  componentId: "sc-storm-ui-30065889__sc-1do8u9s-0"
})(["", " color:", ";margin:0;margin-inline-start:1.5em;display:block;li & li{list-style:lower-alpha;li &{list-style:lower-roman;}}", ""], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.typography.color.base, isMobile(css(["", ""], ({
  theme
}) => theme.typography.mobile.base)));
class OrderedList extends PureComponent {
  render() {
    const {
      children,
      taktId,
      taktValue,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('ordered-list')
    }, /*#__PURE__*/React__default.createElement(StyledList, rest, children));
  }
}
_defineProperty(OrderedList, "propTypes", {
  children: PT.node.isRequired
});

export { OrderedList as O };
//# sourceMappingURL=OrderedList-B9PUI-tm.js.map
